import Box from '@mui/material/Box';
import NavItem from './NavItem';
import PropTypes from 'prop-types';
import React from 'react';
import { SimButton } from 'components/SimButton';
import simsoulsLogoColor from 'assets/images/simsoulsLogoColor.png';
import { useTheme } from '@mui/material/styles';

const SidebarNav = ({ pages }) => {
	const theme = useTheme();
	const { mode } = theme.palette;

	const { linkTreeFLAT: linkTreeFLATPages, sidebarMenu: sidebarMenuPages } = pages;

	return (
		<Box>
			<Box width={1} paddingX={2} paddingY={1}>
				<Box display={'flex'} component='a' href='/' title='theFront' width={{ xs: 100, md: 120 }}>
					<Box
						component={'img'}
						src={mode === 'light' ? simsoulsLogoColor : simsoulsLogoColor}
						height={1}
						width={1}
					/>
				</Box>
			</Box>
			<Box paddingX={2} paddingY={2}>
				<Box>
					<NavItem primeTabs={sidebarMenuPages} linkTreeFLAT={linkTreeFLATPages} />
				</Box>
				<Box marginTop={2}>
					<SimButton size={'large'} variant='outlined' component='a' href='auth/login'>
						Sign Up / Log in
					</SimButton>
				</Box>
			</Box>
		</Box>
	);
};

SidebarNav.propTypes = {
	pages: PropTypes.object.isRequired
};

export default SidebarNav;
